import { Button } from '@/trailmix/Button';
import { IconButton } from '@/trailmix/IconButton';
import { useToast } from '@chakra-ui/react';
import { mdiShareVariant } from '@mdi/js';
import Icon from '@mdi/react';

export function ShareButton({ size = 'sm' }: { size?: 'sm' | 'md' }) {
    const toast = useToast();

    const onClick = async () => {
        if (navigator.share && navigator.canShare()) {
            await navigator.share({
                title: document.title,
                url: document.URL,
            });
        } else {
            await navigator.clipboard.writeText(document.URL);
            toast({
                title: 'Copied to clipboard.',
                status: 'success',
                duration: 5000,
                isClosable: true,
                position: 'top',
                variant: 'left-accent',
            });
        }
    };

    if (size === 'md') {
        return (
            <Button onClick={onClick} size={size} leftIcon={<Icon path={mdiShareVariant} className='size-4' />}>
                Share
            </Button>
        );
    }

    return (
        <IconButton
            onClick={onClick}
            size={size}
            icon={<Icon path={mdiShareVariant} className='size-4' />}
            aria-label='share'
        />
    );
}
